"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return MarkersManager;
    },
    flatMarkerArray: function() {
        return flatMarkerArray;
    },
    getMarkerById: function() {
        return getMarkerById;
    },
    getVisibleStandardMarkers: function() {
        return getVisibleStandardMarkers;
    }
});
const _enums = require("../../enums");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function getMarkerById(id = "", markers = []) {
    var _markers_find;
    return (_markers_find = markers.find((marker)=>marker.id === id)) !== null && _markers_find !== void 0 ? _markers_find : {};
}
function getVisibleStandardMarkers(MARKERS = {}) {
    const { STANDARD = {} } = MARKERS;
    const standardMarkers = Object.entries(STANDARD).reduce((acc, [markerName, data])=>{
        var _data_characteristics;
        if (((_data_characteristics = data.characteristics) === null || _data_characteristics === void 0 ? void 0 : _data_characteristics.markerEnabledFlag) === true) {
            acc.push(markerName);
        }
        return acc;
    }, []);
    return standardMarkers;
}
function flatMarkerArray(MARKERS = {}) {
    /**
   * Returns:       flat array of marker objects
   * Return Value:  [{type, id, data}, ...]
   * Note:          supports optional ordering
   */ const { STANDARD = {}, USERDEFINED = {} } = MARKERS;
    const standardMarkers = Object.entries(STANDARD).map(([markerName, data])=>({
            id: markerName,
            name: markerName,
            type: _enums.MarkerShapesStandard[markerName],
            standard: true,
            data
        }));
    const userdefinedMarkers = Object.entries(USERDEFINED).flatMap(([markerType, markers])=>Object.entries(markers).map(([uniqueIDString, markerData])=>{
            var _markerData_characteristics;
            return {
                id: uniqueIDString,
                name: markerData === null || markerData === void 0 ? void 0 : (_markerData_characteristics = markerData.characteristics) === null || _markerData_characteristics === void 0 ? void 0 : _markerData_characteristics.markerName,
                type: markerType,
                standard: false,
                data: markerData
            };
        }));
    return [
        ...standardMarkers,
        ...userdefinedMarkers
    ];
}
class MarkersManager {
    set(markers) {
        this.markers = markers;
    }
    get() {
        return JSON.parse(JSON.stringify(this.markers));
    }
    getByID(id) {
        return getMarkerById(id, this.markerArray);
    }
    deleteById(id) {
        const updatedMarkers = _object_spread({}, this.markers);
        for(const markerType in updatedMarkers){
            for(const uniqueIDString in updatedMarkers[markerType]){
                if (uniqueIDString === id) {
                    delete updatedMarkers[markerType][uniqueIDString];
                }
            }
        }
        this.markers = updatedMarkers;
    }
    constructor(MARKERS = {}){
        this.markers = MARKERS;
        this.markerArray = flatMarkerArray(MARKERS);
    }
}
